import type { MessageViewer } from '@/entities/room'

export type ViewsAvatarStack = {
  contactIds: string[]
  overflowCount: number
}

const MAX_VISIBLE_WITHOUT_OVERFLOW = 4
const VISIBLE_WITH_OVERFLOW = 3

export const getViewsAvatarStack = (viewers: MessageViewer[]): ViewsAvatarStack => {
  if (viewers.length <= MAX_VISIBLE_WITHOUT_OVERFLOW) {
    return {
      contactIds: viewers.map((viewer) => viewer.contactId),
      overflowCount: 0,
    }
  }

  return {
    contactIds: viewers.slice(0, VISIBLE_WITH_OVERFLOW).map((viewer) => viewer.contactId),
    overflowCount: viewers.length - VISIBLE_WITH_OVERFLOW,
  }
}
